import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { reportComoDataTypes } from "redux/reducers/Reports/reportComoData/types";

const { SET_REPORT_COMO_DATA_FILTERS } = reportComoDataTypes;

export const getReportComoDataAction = ({year, station, isPdf = true}) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/reports/commodatos?year=${year}&idStation=${station.id}&pdf=${isPdf}`;
    const fileName = `Reporte_ComoDatos_${station.name}_${year}.${isPdf ? "pdf" : "xlsx"}`;

    dispatch(startRequestComp('loadingReportComoData'));
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth,
    };
    try {
      const pdf = await axios(access);
      saveAs(pdf.data, fileName);
      dispatch(setSnackbar(`${isPdf ? 'PDF' : 'Excel'} Descargado con éxito`, "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingReportComoData'));
    }
  };
};

export const setReportComoDataFilters = (key = "", value) => {
  return {
    type: SET_REPORT_COMO_DATA_FILTERS,
    payload: { value, key },
  };
};
